import { useContext, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import EnrollmentService from 'services/enrollmentService';
import SectionService from 'services/sectionService';
import SectionData from 'types/SectionData';
import { AuthContext } from 'utils/AuthProvider';

import AdminContent from './AdminContent';
import CompletedContent from './CompletedContent';
import DefaultContent from './DefaultContent';
import SkillData from '../../../types/skillData';
import Card from '../../organisms/Card';

import './SkillCard.scss';
import clsx from 'clsx';

interface SkillCardProps {
  skill: SkillData;
  completed?: boolean;
  showAdminView?: boolean;
  animated?: boolean;
  onDelete?: (skill: SkillData) => void;
  onTogglePublish?: (skill: SkillData) => void;
  className?: string;
}

export default function SkillCard({
  skill,
  completed = false,
  showAdminView = false,
  animated = false,
  onDelete = () => {},
  onTogglePublish = () => {},
  className = '',
}: SkillCardProps) {
  const backgroundImageUrl = skill.imageUrl;
  const [isEnrolled, setIsEnrolled] = useState<boolean>();
  const [firstIncompleteSection, setFirstIncompleteSection] = useState<SectionData | null>();
  const { user } = useContext(AuthContext)!;

  useEffect(() => {
    async function fetchData() {
      if (!user) return;
      const fetchedIsEnrolled = await EnrollmentService.isUserEnrolledInSkill(user, skill);
      const fetchedFirstIncompleteSection = await SectionService.getFirstIncompleteSection(skill, user);
      setIsEnrolled(fetchedIsEnrolled);
      setFirstIncompleteSection(fetchedFirstIncompleteSection);
    }

    fetchData();
  }, [user, skill]);

  const heroStyle = {
    backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined,
  };

  const hero = !showAdminView ? (
    <div className="hero" style={heroStyle} />
  ) : (
    <Link to={`/skills/${skill.slug}`}>
      <div className="hero animated" style={heroStyle} />
    </Link>
  );

  const content = showAdminView ? (
    <AdminContent skill={skill} onDelete={onDelete} onTogglePublish={onTogglePublish} />
  ) : completed ? (
    <CompletedContent skill={skill} />
  ) : (
    <DefaultContent skill={skill} isEnrolled={isEnrolled} firstIncompleteSection={firstIncompleteSection} />
  );

  return (
    <Card className={clsx('skill-card overflow-hidden', completed && 'completed', animated && 'animated', className)}>
      <div className="hero-container">{hero}</div>
      <div className="content-container">{content}</div>
    </Card>
  );
}
